import { render } from "./ProductDetail.vue?vue&type=template&id=ac12c0ec&scoped=true"
import script from "./ProductDetail.js?vue&type=script&lang=js&external"
export * from "./ProductDetail.js?vue&type=script&lang=js&external"

import "./ProductDetail.scss?vue&type=style&index=0&id=ac12c0ec&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac12c0ec"]])

export default __exports__